import React from "react";
import { Link } from "react-router-dom";
import { Image } from "react-bootstrap";
import attendanceIcon from "../../assets/attendance-qr-code/attendance.png";
import { usePermission } from "../../hooks/usePermission";

const Settings = () => {
  const { hasPermission } = usePermission();

  if (!hasPermission("settings-list")) {
    return (
      <div className="content-wrapper">
        <div className="container-fluid p-0 mt-0 mb-2">
          <div className="col-lg-12">
            <h5 className="page-title text-danger">Access Denied</h5>
          </div>
        </div>
      </div>
    );
  }

  return (

    <div className="content-wrapper">
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">Attendance QR Code</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
                    </div>
                    <div>
                      <Link to={"/"}>
                        Dashboard
                      </Link>
                    </div>
                  </div>
                </li>

                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
                </li>
                <li><span className="active_breadcrumb">Attendance QR Code</span></li>
              </ol>

            </div>

          </div>
        </div>
      </div>
      <div className="flex-grow-1">

        <div className="row">
          <div className="col-xl-4">
            <div className="card mb-4">
              <div className="card-header d-flex justify-content-between align-items-center">
                {/* <h5 className="mb-0">Show QR Code</h5> */}
              </div>
              <div className="card-body">
                <form>
                  <div className="row">

                    <div className="col-md-6">
                      <div className="mb-3">
                        <Image
                          width={320}
                          height={320}
                          src={attendanceIcon}
                        />
                      </div>
                    </div>


                    <div className="demo-inline-spacing d-flex justify-content-end">
                      <a
                        href={attendanceIcon}
                        download="Attendance-QR-Code.png"
                        className="btn btn-success isubmit_button"
                      >
                        Download
                      </a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
